import { AlertBar, TextLink } from '@civilgrid/ui/components';
import type { ConnectbaseNoticeStatus } from '~/api/projectConnectbaseTasks';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import rootStore from '~/store';
import { useStatusMessageShown } from './useStatusMessageShown';

const SUPPORT_HREF = 'mailto:support@civilgrid.com';

const COPY: Record<ConnectbaseNoticeStatus, { title: string; body: string }> = {
  retrying: {
    title: 'Still Loading Utility Data',
    body: 'Our data provider hasn’t responded yet but we’re still working to fetch this information.',
  },
  failed: {
    title: 'Unable to Load Utility Data',
    body: 'Our data provider had a problem loading information for this project.',
  },
};

/** Tells the user the project's ConnectBase agencies are retrying or have failed, in the Utilities tab. */
export function ConnectbaseNotice({ projectId, status }: { projectId: string; status: ConnectbaseNoticeStatus }) {
  useStatusMessageShown(projectId, 'agencies', status);

  const tone = status === 'retrying' ? 'warning' : 'danger';
  const { title, body } = COPY[status];

  return (
    <div data-testid={`utilities-connectbase-${status}`}>
      <AlertBar variant={tone} icon={tone} title={title}>
        {body}
        {status === 'failed' && (
          <>
            {' '}
            <TextLink
              href={SUPPORT_HREF}
              data-testid="utilities-connectbase-contact-support"
              // TextLink's default blue-50 without an underline fails contrast on the red AlertBar.
              className="text-blue-60 underline hover:text-blue-90"
              onClick={() =>
                captureTypedPosthogEvent(POSTHOG_EVENTS.contactSupportClicked, {
                  organization_id: rootStore.currentOrganizationId,
                  source: 'connectbase_agencies_failed',
                })
              }
            >
              Contact support.
            </TextLink>
          </>
        )}
      </AlertBar>
    </div>
  );
}
